import React from 'react';

import useResponsiveTitle from 'src/hooks/useResponsiveTitle';

import { CopyProps, Variant } from './Copy.types';
import styles from './Copy.module.scss';

export const Copy: React.FC<CopyProps> = ({
  children,
  className = '',
  title,
  subtitle,
  overline,
  paragraph,
  variant = Variant.Dark,
  isLargerTitle = false,
  isXLargeTitle = false,
  isLargerParagraph = false,
  svg,
}) => {
  const responsiveTitle = useResponsiveTitle();
  const titleClass = isXLargeTitle ? 'font-size-title-x-large' : responsiveTitle;

  const getPrimaryColor = () => {
    if (variant === Variant.Light || variant === Variant.Blue) {
      return 'color-white';
    } else {
      return 'color-dark-1';
    }
  };

  const getSecondaryColor = () => {
    if (variant === Variant.Dark) {
      return 'color-light-gray-gradient';
    } else if (variant === Variant.Light) {
      return 'color-light-gray';
    } else {
      return 'color-light-blue';
    }
  };

  const getTertiaryColor = () => (variant === Variant.Light || variant === Variant.Blue ? 'color-white' : '');

  const largerTitleClass = isLargerTitle && !isXLargeTitle ? styles.copy__largerTitle : '';
  const largerParagraphClass = isLargerParagraph ? 'font-size-large-paragraph' : '';

  return (
    <div className={className} data-cy="copy">
      {overline && (
        <p className={`${styles.copy__overline} ${getPrimaryColor()}`} data-cy="copy-overline">
          {overline}
        </p>
      )}
      {svg && <img className={`${styles.copy__overline}`} src={svg} alt="icon" />}
      <h2 className={`no-padding ${getPrimaryColor()} ${titleClass} ${largerTitleClass}`} data-cy="copy-title">
        {title}
      </h2>
      {subtitle && (
        <h3 className={`no-padding ${getSecondaryColor()} ${titleClass} ${largerTitleClass}`} data-cy="copy-subtitle">
          {subtitle}
        </h3>
      )}
      {paragraph && (
        <p
          className={`${styles.copy__paragraph} ${largerParagraphClass} ${getTertiaryColor()}`}
          data-cy="copy-paragraph"
          dangerouslySetInnerHTML={{ __html: paragraph }}
        ></p>
      )}
      {children && <div className={styles.copy__container}>{children}</div>}
    </div>
  );
};
